// Helper para normalizar el objeto profiles
export const normalizeProfile = (profileData: any): { username: string; avatar_url: string | null; karma_points?: number } | null => {
  if (!profileData) return null;
  // Si Supabase devuelve un array de un solo elemento para una relación 1:1
  if (Array.isArray(profileData) && profileData.length > 0) {
    return profileData[0];
  }
  // Si ya es un objeto
  if (typeof profileData === 'object' && profileData !== null) {
    return profileData;
  }
  return null;
};